import { render, staticRenderFns } from "./LastMinuteCourseList.vue?vue&type=template&id=13c4a90e&scoped=true"
import script from "./LastMinuteCourseList.vue?vue&type=script&lang=js"
export * from "./LastMinuteCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4a90e",
  null
  
)

export default component.exports